import axios from 'axios';
import { IRetrievalCollection, IRetrievalCollectionPayload } from 'entities/Retrieval/Retrieval.models';

const basePath = 'retrievals';

export const retrievalTransport = {
  getRetrievalCollection: (payload: IRetrievalCollectionPayload): Promise<IRetrievalCollection> =>
    axios.get(`${basePath}`, { params: payload }),
};
